import { FocusEventHandler } from "react";

import { TAB_INDEX_FOCUSABLE_ORDER_EXPLICIT } from "@multiweb/reactUtils";
import { OnChangeHandler, OptionalTabIndex } from "@multiweb/types/react";

/** Výčet možných umístění popisu vůči checkboxu */
export enum CaptionAlignment {
    leftJustify = "taLeftJustify",
    rightJustify = "taRightJustify",
}

/** Typ hodnoty uložené v checkboxu */
export type CheckBoxComponentValue = boolean | undefined;

/** Props sdílené mezi interními komponentami CheckBoxComponent */
export type CheckBoxComponentSharedProps = Readonly<{
    /** Příznak, zda je zaškrtávací pole třístavové */
    hasThreeStates?: boolean;
    /** Vysvětlivka pole */
    title?: string;
    /** Hodnota pole */
    value: CheckBoxComponentValue;
    /** Callback volaný při změně hodnoty pole */
    onChange?: OnChangeHandler<CheckBoxComponentValue>;
    /** Callback volaný při opuštění pole */
    onBlur?: FocusEventHandler<HTMLDivElement>;
    /** Příznak, zda se pro hodnotu `false` dvoustavového checkboxu zobrazí červený křížek */
    showFalseAsCrossed?: boolean;
    /** Umožňuje nastavit tabindex */
    tabIndex?: OptionalTabIndex | typeof TAB_INDEX_FOCUSABLE_ORDER_EXPLICIT;
}>;
